/*
 * This file is generated. Don't edit it directly.
 * Modify `scripts/generate-mjml-react.ts` to make changes to these files
 */
import React from "react";
import { convertPropsToMjmlAttributes } from "../utils";
export function MjmlBreakpoint(props) {
    return React.createElement("mj-breakpoint", convertPropsToMjmlAttributes(props));
}
